import { className } from "@material-tailwind/react/types/components/accordion";

interface NormalPageProps {
    children: React.ReactNode;
    bgColor?: string;
    xlBgColor?: string;
    paddingY?: number;
    paddingX?: number;
    className?: className;
    /** 헤더 없이 단독으로 렌더링되는 라우트는 false. 헤더 높이만큼 빼지 않고 화면 전체를 사용한다. */
    hasHeader?: boolean;
}
const NormalPage: React.FC<NormalPageProps> = ({
    children,
    bgColor = "white",
    xlBgColor = "white",
    paddingX = 5,
    paddingY = 6,
    className,
    hasHeader = true,
}) => {
    const minHeight = hasHeader ? "min-h-normal xl:min-h-normal_pc" : "min-h-dvh";

    return (
        <>
            <div
                className={`relative px-${paddingX} pt-${paddingY} xl:p-0 bg-${bgColor} xl:bg-${xlBgColor} ${minHeight} ${className ?? ""}`}
            >
                {children}
            </div>
        </>
    );
};
export default NormalPage;
